// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","logo":"styles_logo__uO33l","hamburger":"styles_hamburger__epLzE","open":"styles_open__CW7yM"};